export function simpleHash(str) {
    let hash = 0;
    if (str.length === 0) return '000000'; // Default hash for empty string

    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash |= 0; // Convert to 32bit integer
    }
    let hashedStr = Math.abs(hash).toString(36).padStart(6, '0');
    return hashedStr.substring(0, 6); // Ensure it's exactly 6 chars
}